import { validateConditionaly } from '@sravni/cosago-react-library/lib/validationSchemes';
import type { AnySchema } from 'yup';
import { mixed } from 'yup';

import type { TPledgeEstateFields } from 'entities/pledgeEstateForm';

export const validateFieldIfHasOtherOwner = <T>(fieldSchema: AnySchema) =>
  validateConditionaly<T>(
    (isOnlyOwner: TPledgeEstateFields['isOnlyOwner']) => !isOnlyOwner,
    () => fieldSchema,
    () => mixed().nullable(),
  )('isOnlyOwner');
